import { getCookie } from '@app/services'
import { compareVersions } from '@app/utils'


export enum WebViewFeature {
  DelegatedJwtExchange = 'delegated_jwt_exchange'
}

const FEATURE_MIN_VERSIONS: Record<
  WebViewFeature,
  { android?: string; ios?: string }
> = {
  [WebViewFeature.DelegatedJwtExchange]: {
    android: '2.31.00-beta1',
    ios: '2.40.0',
  },
}

const getWebViewVersion = (): {
  platform: 'android' | 'ios' | null
  version: string | null
} => {
  const userAgent = getCookie('userAgent') || navigator.userAgent || ''
  
  const ANDROID_VERSION_REGEX = /PowerMobileAndroid\/([0-9A-Za-z.+-]+)/
  const IOS_VERSION_REGEX = /PowerMobile\s+iOS\/([0-9A-Za-z.+-]+)/

  // Android: PowerMobileAndroid/2.31.00-beta1 ...
  const androidMatch = userAgent.match(ANDROID_VERSION_REGEX)
  if (androidMatch) {
    return { platform: 'android', version: androidMatch[1] }
  }
  
  // iOS:     PowerMobile iOS/2.40.0 ...
  const iosMatch = userAgent.match(IOS_VERSION_REGEX)
  if (iosMatch) {
    return { platform: 'ios', version: iosMatch[1] }
  }

  return { platform: null, version: null }
}

export const hasFeature = (feature: WebViewFeature): boolean => {
  const min = FEATURE_MIN_VERSIONS[feature]
  if (!min) return false

  const { platform, version } = getWebViewVersion()
  if (!platform || !version) return false

  const required = platform === 'android' ? min.android : min.ios
  if (!required) return false

  return compareVersions(version, required) >= 0
}